import React from "react";

import { AppContextProvider } from "@public/context/App/App.context";
import { AppSelectionContextProvider } from "@public/context/App/AppSelectionContext";
import { PageNavigation } from "@public/layouts/components/PageNavigation";
import { UserFeedbackActivityHistoryPage } from "@public/pages/UserFeedback/UserFeedback";
import { Navigate, useParams } from "react-router-dom";

import { Layouts } from "../Layouts";
import * as Styled from "./MainLayoutView.styles";

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export default function ActivityHistoryLayoutView() {
  const { issueId } = useParams();
  const isValidUuid = UUID_REGEX.test(issueId || "");

  if (!isValidUuid)
    return (
      <Navigate
        to="/not-found"
        replace
      />
    );

  return (
    <AppContextProvider>
      <AppSelectionContextProvider>
        <Styled.Container>
          <Layouts />
          <Styled.InnerContainer>
            <PageNavigation bottomBorder={false} />
            <UserFeedbackActivityHistoryPage />
          </Styled.InnerContainer>
        </Styled.Container>
      </AppSelectionContextProvider>
    </AppContextProvider>
  );
}
